import { Card, DatePicker, Select, Input, Button, Table, Space, Tag, message } from 'antd'
import { FilterOutlined, SearchOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import axios from 'axios'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker

function SendLogs() {
  const [dateRange, setDateRange] = useState([dayjs().subtract(7, 'day'), dayjs()])
  const [status, setStatus] = useState('all')
  const [search, setSearch] = useState('')
  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)

  const token = localStorage.getItem('token')
  const headers = { Authorization: `Bearer ${token}` }

  const fetchLogs = async (targetPage = page, targetPageSize = pageSize) => {
    setLoading(true)
    try {
      const params = {
        date_from: dayjs(dateRange[0]).format('YYYY-MM-DD'),
        date_to: dayjs(dateRange[1]).format('YYYY-MM-DD'),
        limit: targetPageSize,
        offset: (targetPage - 1) * targetPageSize
      }
      if (status !== 'all') params.status = status
      if (search.trim()) params.search = search.trim()

      const res = await axios.get('/api/settings/send-logs', { headers, params })
      setRows(res.data.rows)
      setTotal(res.data.total)
    } catch (err) {
      message.error(err.response?.data?.error || 'خطأ في جلب سجل الإرسال')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchLogs(1, pageSize)
    setPage(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSearch = () => {
    setPage(1)
    fetchLogs(1, pageSize)
  }

  const handleTableChange = (pagination) => {
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
    fetchLogs(pagination.current, pagination.pageSize)
  }

  const documentTypeLabel = (type) => {
    const labels = { bill: 'فاتورة' }
    return labels[type] || type
  }

  const columns = [
    {
      title: 'التاريخ والوقت', dataIndex: 'sent_at', key: 'sent_at', width: 170,
      render: v => dayjs(v).format('YYYY-MM-DD HH:mm:ss')
    },
    { title: 'رقم الجوال', dataIndex: 'recipient_phone', key: 'recipient_phone', width: 140,
      render: v => v || <span style={{ color: '#ccc' }}>—</span> },
    { title: 'نوع المستند', dataIndex: 'document_type', key: 'document_type', width: 110,
      render: v => <Tag color="blue">{documentTypeLabel(v)}</Tag> },
    { title: 'رقم المستند', dataIndex: 'document_number', key: 'document_number', width: 130 },
    {
      title: 'الحالة', dataIndex: 'status', key: 'status', width: 110,
      render: v => v === 'sent'
        ? <Tag color="green">تم الإرسال</Tag>
        : <Tag color="red">فشل</Tag>
    },
  ]

  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <Space size="middle" wrap align="end">
          <div>
            <div style={{ fontSize: 12, color: '#1c599e', fontWeight: 600, marginBottom: 4 }}>الفترة</div>
            <RangePicker value={dateRange} onChange={setDateRange} />
          </div>
          <div>
            <div style={{ fontSize: 12, color: '#1c599e', fontWeight: 600, marginBottom: 4 }}>الحالة</div>
            <Select
              value={status}
              style={{ width: 150 }}
              onChange={setStatus}
              options={[
                { label: 'الكل', value: 'all' },
                { label: 'تم الإرسال', value: 'sent' },
                { label: 'فشل', value: 'failed' },
              ]}
            />
          </div>
          <div>
            <div style={{ fontSize: 12, color: '#1c599e', fontWeight: 600, marginBottom: 4 }}>بحث (جوال أو رقم مستند)</div>
            <Input
              placeholder="ابحث..."
              style={{ width: 200 }}
              allowClear
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onPressEnter={handleSearch}
            />
          </div>
          <div>
            <div style={{ fontSize: 12, marginBottom: 4 }}>&nbsp;</div>
            <Button type="primary" icon={<FilterOutlined />} loading={loading} onClick={handleSearch}>
              بحث
            </Button>
          </div>
        </Space>
      </Card>

      <Card>
        <Table
          columns={columns}
          dataSource={rows}
          rowKey="id"
          loading={loading}
          onChange={handleTableChange}
          pagination={{
            current: page,
            pageSize,
            total,
            showSizeChanger: true,
            showTotal: (t) => `إجمالي ${t} سجل`
          }}
          size="small"
        />
      </Card>
    </div>
  )
}

export default SendLogs
